// import Swiper from "swiper/bundle";
// import Swiper, { Navigation, Pagination, EffectFade } from "swiper";
// Swiper.use([Navigation, Pagination, EffectFade]);
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
Swiper.use([Navigation, Pagination, EffectFade]);

export default class {
	constructor(options) {
		const scopeThis = this;
		this.defaults = {
			$el: null,
			minItems: 2,
			swiperArgs: {
				slidesPerView: "auto",
				grabCursor: true,
				loop: true,
				autoadvance: false,
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: true,
				},
				preventClicks: true,
				freeMode: true,
				// cssMode: true,
				pagination: {
					el: ".swiper-pagination",
				},
				// mousewheel: {
				// 	forceToAxis: true,
				// 	releaseOnEdges: true,
				// },
				keyboard: {
					enabled: true,
					// onlyInViewport: true,
				},
				autoopts: {
					currcycle: 0,
					maxcycle: 1000,
				},
				// navigation: {
				//   nextEl: '.swiper-' + randAttribute + ' .swiper-btn-next',
				//   prevEl: '.swiper-' + randAttribute + ' .swiper-btn-prev',
				// },
				on: {
					init: function (swiper) {
						// swiper.el.addEventListener("keydown", function (e) {
						// 	if (e.key === "Tab") {
						// 		var focusEl =
						// 			document.activeElement.closest(
						// 				".swiper-slide"
						// 			);
						// 		if (
						// 			null != focusEl &&
						// 			!focusEl.classList.contains(
						// 				"swiper-slide-active"
						// 			)
						// 		) {
						// 			var slideIndex =
						// 				Array.prototype.indexOf.call(
						// 					focusEl.parentNode.children,
						// 					focusEl
						// 				);
						// 			this.swiper.slideTo(slideIndex);
						// 		}
						// 	}
						// });
					},
				},
			},
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "SwiperSlideshow";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			let args = this.options.swiperArgs;
			let elScope = this.$el;

			if (this.$el.classList.contains("feature-carousel")) {
				args.centeredSlides = false;
				this.options.minItems = 2;
				args.minItems = 2;
				args.slidesPerView = "auto";
				args.loop = false;
				args.spaceBetween = 0;
				// gap between slides
				// args.spaceBetween = 30;
			}

			if (this.$el.classList.contains("cohort-carousel-wrap")) {
				args.centeredSlides = false;
				args.slidesPerView = "auto";
				args.loop = false;
				args.spaceBetween = 0;
			}

			if (this.$el.classList.contains("focus-carousel")) {
				args.centeredSlides = true;
				args.slidesPerView = "auto";
				args.loop = false;
				args.spaceBetween = 0;
			}
			if (this.$el.classList.contains("gal-open")) {
				args.effect = "fade";
				args.loop = true;
			}

			if (
				!this.$el.classList ||
				this.$el.querySelectorAll(".swiper-slide").length <
					this.options.minItems ||
				this.$el.classList.contains("no-carousel")
			) {
				this.$el.classList.add("no-carousel");
				return;
			}

			args.navigation = {
				nextEl: this.$el.parentElement.querySelector(".next"),
				prevEl: this.$el.parentElement.querySelector(".prev"),
			};

			if (this.$el.classList.contains("auto-advance")) {
				args.autoadvance = true;
			}

			// console.log(args);

			this.swiper = new Swiper(this.$el, args);

			if (this.$el.classList.contains("gal-open")) {
				// on init and every time a slide changes, set the caption-(index) to 'active' and set all other captions to not active
				this.swiper.on("init slideChange", function () {
					let activeIndex = this.activeIndex;
					let $caption = document.querySelector(
						".caption-" + activeIndex
					);
					let $captions = document.querySelectorAll(
						".page-hero-caption .caption"
					);
					if ($captions && $captions.length) {
						$captions.forEach((el) => {
							el.classList.remove("active");
						});
					}
					if ($caption) {
						$caption.classList.add("active");
					}
				});
			}

			// console.log(args);

			// if (args.autoadvance) {
			// 	if (this.options.heroGal) {
			// 		let appScope = this;
			// 		appScope.setGalleryTextHeight();
			// 	}
			// 	this.timerTick();
			// } else {
			// 	// console.log("not auto advancing");
			// }
		} else {
			this.swiper.destroy(true, true);
		}
	}

	timerTick() {
		// let scopeThis = this;
		// let args = scopeThis.options.swiperArgs;
		// if (!args.autoadvance) {
		// 	// console.log("bailing because autoadvance false");
		// 	return;
		// }
		// args.autoopts.currcycle++;
		// // console.log(args.autoopts.currcycle);
		// if (args.autoopts.currcycle >= args.autoopts.maxcycle) {
		// 	scopeThis.swiper.slideNext();
		// 	args.autoopts.currcycle = 0;
		// }
		// let newFuse = (args.autoopts.currcycle * 1.1) / args.autoopts.maxcycle;
		// if (newFuse > 1) {
		// 	newFuse = 1;
		// }
		// scopeThis.$el.setAttribute("style", "--autoprogress:" + newFuse);
		// // requestAnimationFrame(scopeThis.timerTick);
		// setTimeout(function () {
		// 	scopeThis.timerTick();
		// }, 1);
	}
}
